import { gql } from "@medbillai/generated-graphql-types";

export const checkFaEligibilityMutation = gql(/* GraphQL */ `
  mutation CheckFaEligibility($input: CheckFaEligibilityInput!) {
    checkFaEligibility(input: $input) {
      outcome
    }
  }
`);

export const acceptTermsMutation = gql(/* GraphQL */ `
  mutation AcceptTerms($input: AcceptTermsInput!) {
    acceptTerms(input: $input) {
      ok
    }
  }
`);

export const recordIdentityMutation = gql(/* GraphQL */ `
  mutation RecordIdentity($input: RecordIdentityInput!) {
    recordIdentity(input: $input) {
      ok
    }
  }
`);

export const recordPhoneMutation = gql(/* GraphQL */ `
  mutation RecordPhone($input: RecordPhoneInput!) {
    recordPhone(input: $input) {
      ok
    }
  }
`);

export const recordInsuranceMutation = gql(/* GraphQL */ `
  mutation RecordInsurance($input: RecordInsuranceInput!) {
    recordInsurance(input: $input) {
      ok
    }
  }
`);

export const searchPayersQuery = gql(/* GraphQL */ `
  query OnboardingSearchPayers($input: SearchPayersInput!) {
    searchPayers(input: $input) {
      id
      primaryPayerId
      displayName
      logoUrl
      memberIdRequired
    }
  }
`);

export const popularPayersQuery = gql(/* GraphQL */ `
  query OnboardingPopularPayers {
    popularPayers {
      id
      primaryPayerId
      displayName
      logoUrl
      memberIdRequired
    }
  }
`);

export const recordInsuranceStatusMutation = gql(/* GraphQL */ `
  mutation RecordInsuranceStatus($input: RecordInsuranceStatusInput!) {
    recordInsuranceStatus(input: $input) {
      ok
    }
  }
`);

// Resume flags are derived from the canonical stores (persons, segmentation,
// user memory) — there is no dedicated onboarding aggregate.
export const onboardingStateQuery = gql(/* GraphQL */ `
  query OnboardingDerivedState {
    me {
      id
      acceptedTermsAt
      persons(order: { primary: { dir: DESC } }) {
        id
        primary
        givenNames
        familyName
        dateOfBirth
      }
      segmentationData {
        id
        hasInsurance
        features
      }
    }
    projection__UserMemory {
      id
      entries
    }
    viewerPartner {
      id
      slug
      name
    }
  }
`);

export const upsertOnboardingIntentMutation = gql(/* GraphQL */ `
  mutation UpsertOnboardingIntent($input: UpsertUserSegmentationDataInput!) {
    upsertUserSegmentationData(input: $input) {
      id
    }
  }
`);
